
import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import TableRenderer from "./TableRenderer";
import { BlueEye } from "../AllSvg";

const CustomShowTableData = ({
    title = "Details",
    buttonLabel = "View",
    layout = "horizontal",
    columns = [],
    data = [],
    actions = [],
}) => {
    const [show, setShow] = useState(false);

    return (
        <>
            <button className="text-button allproject-dashboard" onClick={() => setShow(true)}>
                <BlueEye /> {buttonLabel}
            </button>

            <Modal show={show} onHide={() => setShow(false)} dialogClassName="three-fourth-modal">
                <Modal.Header closeButton>
                    <Modal.Title className="text-capitalize">{title}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div style={{ maxHeight: "70vh", overflowY: "auto" }}>
                        <TableRenderer columns={columns} data={data} layout={layout} actions={actions} />
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default CustomShowTableData;
